import { useDeviceType } from '@cian/ui-kit';
import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { GiftBanner } from 'shared/components/GiftBanner';
import { useAppDispatch } from 'shared/hooks';
import { selectLead } from 'shared/selectors/lead';
import { setVisible } from 'shared/slices';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const GiftBannerContainer: React.FC = () => {
  const device = useDeviceType();
  const containerRef = useRef<HTMLDivElement>(null);
  const hasOpenedRef = useRef(false);

  const lead = useSelector(selectLead);

  const dispatch = useAppDispatch();

  const { custom } = useApplicationContext();

  const handleOpenModal = useCallback(() => {
    dispatch(setVisible(true));
  }, [dispatch]);

  useEffect(() => {
    if (device === 'desktop' || hasOpenedRef.current || lead.exists === true) {
      return;
    }

    const container = containerRef.current;
    if (!container) {
      return;
    }

    const checkIntersection = () => {
      if (hasOpenedRef.current) {
        return;
      }

      const rect = container.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom > 0) {
        hasOpenedRef.current = true;
        handleOpenModal();
      }
    };

    checkIntersection();

    window.addEventListener('scroll', checkIntersection, { passive: true });

    return () => {
      window.removeEventListener('scroll', checkIntersection);
    };
  }, [custom.cianUserId, device, handleOpenModal, lead.exists]);

  return <GiftBanner containerRef={containerRef} device={device} handleOpenModal={handleOpenModal} />;
};
